export class Component {
  _componentBrand: void;
}
